import {EiImportRecordStructureService} from "./service/api/ei-import-record-structure.service";
import {EiImportRecordService} from "./service/api/ei-import-record.service";
import {EiImportService} from "./service/api/ei-import.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
// Registry now points to the NEW EiImportObjectComponent (refactored from the
// former `EiImportDetailPage`). The legacy class lives on as
// `EiImportObjectDeprecatedComponent` and is no longer referenced here.
import {EiImportObjectComponent} from "./page/ei-import-detail/ei-import-object.component";
import {
    EiImportRecordStructureObjectComponent
} from "./component/protected-components/ei-import-record-structure-object-component/ei-import-record-structure-object.component";
import {
    EiImportRecordObjectComponent
} from "./component/protected-components/ei-import-record-object-component/ei-import-record-object.component";
import {
    EiImportTypeComponent
} from "./component/protected-components/object-component/ei-import-type-object-component/ei-import-type.component";
import {
    EiStructureObjectComponent
} from "./component/protected-components/ei-structure-object-component/ei-structure-object.component";
import {
    EiStructureFieldComponent
} from "./component/protected-components/object-component/ei-structure-field-object-component/ei-structure-field.component";

export const EI_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['ei.EiStructureFieldValue', {route: '/ei/eiStructureFieldValues'}],
            ['ei.EiStructureFieldLogicImport', {route: '/ei/eiStructureFieldLogicImports'}],
            ['ei.EiImportRecordStructure', {
                route: '/ei/eiImportRecordStructures',
                service: EiImportRecordStructureService,
                objectComponent: [{component: EiImportRecordStructureObjectComponent}],
            }],
            ['ei.EiStructureField', {
                route: '/ei/eiStructureFields',
                objectComponent: [{component: EiStructureFieldComponent}],
            }],
            ['ei.EiImportType', {
                route: '/ei/eiImportTypes',
                objectComponent: [{component: EiImportTypeComponent}],
            }],
            ['ei.EiImportRecord', {
                route: '/ei/eiImportRecords',
                service: EiImportRecordService,
                objectComponent: [{component: EiImportRecordObjectComponent}],
            }],
            ['ei.EiStructure', {
                route: '/ei/eiStructures',
                objectComponent: [{component: EiStructureObjectComponent}],
            }],
            ['ei.EiImportRecordStructureField', {route: '/ei/eiImportRecordStructureFields'}],
            ['ei.EiStructureStrategySearchField', {route: '/ei/eiStructureStrategySearchFields'}],
            ['ei.EiImport', {route: '/ei/eiImports', objectRoute: '/ei/import/:id', service: EiImportService, objectComponent: [{component: EiImportObjectComponent}]}],
            ['ei.EiStructureConditionLogicImport', {route: '/ei/eiStructureConditionLogicImports'}],
            ['ei.EiStructureQlQueryParam', {route: '/ei/eiStructureQlQueryParams'}],
            ['ei.EiStructureValidationQlParam', {route: '/ei/eiStructureValidationQlParams'}],
            // M-P4-03: Fachbereichs-Leitstand — read-only via QL, no custom service file needed
            ['ei.EiImportRecordOutcome', {route: '/ei/eiImportRecordOutcomes'}],
            ['ei.EiImportRecordStructureFieldConflict', {route: '/ei/eiImportRecordStructureFieldConflicts'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
